export const option = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchMenuSpan: 6,
  searchLabelWidth: 100,
  labelWidth: 150,
  border: true,
  index: true,
  menu: false,
  indexLabel: '序号',
  selection: false,
  viewBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  column: [
    {
      label: '公司名称',
      prop: 'businessdDeptName',
      display: false,
      search: false,
    },
    {
      label: '资料名称',
      prop: 'busTypeName',
      display: false,
      search: false,
    },
    {
      label: '关联进件编号',
      prop: 'businessCode',
      span: 24,
      display: false,
    },
    {
      label: '租赁人',
      prop: 'name',
      span: 24,
      display: false,
    },
    {
      label: '车牌号',
      prop: 'carFirstNumber',
      span: 24,
      display: false,
    },
    {
      label: '数量',
      prop: 'amount',
      display: false,
      search: false,
    },
    {
      label: 'id',
      prop: 'businessDeptId',
      display: false,
      hide: true,
    },
    {
      label: '申请时间',
      prop: 'applicationDate',
      display: false,
      search: false,
    },
    // {
    //   label: '状态',
    //   prop: 'applyStatus',
    //   display: false,
    //   search: false,
    //   dicData:[
    //     {
    //       label:'申请中',
    //       value:1
    //     },
    //     {
    //       label:'已通过',
    //       value:2
    //     },
    //     {
    //       label:'已驳回',
    //       value:3
    //     },
    //   ]
    // },
  ],

};
